<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select
              ref="smComboFrame0"
              :pageId="this.$options.name"
              :selectedMd="frame0.selectedCode.COD_MDLE"
              :selectedSmd="frame0.selectedCode.COD_SMDLE"
              defaultMdOption="all"
              defaultSmdOption="all"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RUL_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="ruleTypeCode"
              :selected="frame0.selectedCode.COD_TYPE"
              codeId="COD_RULE_TYPE"
              defaultOption="all"
              :initialSelectedIndex="0"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RUL_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="frame0.ruleName"
              maxlength="50"
              @keyup.enter="onClickSearch"
            />
          </div>      
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ACTV_YN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-yn-select
              ref="activate"
              defaultOption="all"
              :selected="frame0.selectedCode.COD_ACTV"
              :initialSelectedIndex="0"
            />
          </div>         
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset "
            @click="onClickReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid"
        :columns="gridColumns0"
        :dataset="'dsRule'"
        :showDisplayCountControl="false"
      />
      <div class="mrB30" />
      <sui-page-tab-box-type
        ref="tab"
        :tabItems="tabItems"
        :defaultTabIndex="defaultTabIndex"
        :setCurrentTabComponent="setCurrentTabComponent"
        @change-tab-idx="onChangeTabIdx"
      >
        <container
          :is="currentTabComponent"
          :selectedRowData="selectedRowData"
          :pageId="$options.name"
          :ruleUid="ruleUid"
          :actionMappingList="actionMappingList"
          :setRuleConditionInfo="setRuleConditionInfo"
          @onClickNew="onClickNew"
          @onClickSearch="onClickSearch"
          @onPopupCall="onPopupCall"
          @setRuleInfo="setRuleInfo"
          @page-deactivate="handleChildDeactivated"
          @page-activate="handleChildActivated"
        />
      </sui-page-tab-box-type>
    </sui-page-contents>
    <sui-popup
      v-model="isShownPopup"
      :title="$t('MSG_TIT_ACN_SELT')"
    >
      <p01
        :ruleUid="ruleUid"
        :pageId="$options.name"
        :actionMappingList="actionMappingList"
        :selectedRowData="selectedRowData"
        :setRuleConditionInfo="setRuleConditionInfo"
        @onPopupClose="onPopupClose"
        @paramReturn="paramReturn"
      />
    </sui-popup>
  </sui-page>
</template>
<script>
import tab01 from './components/PGE_CMR_00001_T01';
import tab02 from './components/PGE_CMR_00001_T02';
import tab03 from './components/PGE_CMR_00001_T03';
import tab04 from './components/PGE_CMR_00001_T04';
import tab05 from './components/PGE_CMR_00001_T05';
import p01 from './components/PGE_CMR_00001_P01';
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMR_00001', // eslint-disable-line vue/name-property-casing
  components: {
    tab01,
    tab02,
    tab03,
    tab04,
    tab05,
    p01,
  },
  extends: BasePage,
  data() {
    return {
      setRuleConditionInfo: {},
      selectedRowData: {},
      ruleUid: '',
      isShownPopup: false,
      popupTitle: '',
      popupComponents: '',
      actionMappingList: [],
      frame0: {
        selectedCode: {
          COD_TYPE: {
            key: '',
            label: '',
          },
          COD_MDLE: {
            key: '',
            label: '',
          },
          COD_SMDLE: {
            key: '',
            label: '',
          },
          COD_ACTV: {
            key: '',
            label: '',
          },
        },
        ruleUid: '',
        ruleName: '',
      },
      selectedPageID: '',
      tabItems: [
        {
          tabTitle: this.$t('MSG_TXT_DEFAULT_INFO'), // '기본정보'
          tabComponent: tab01,
        },
        {
          tabTitle: this.$t('MSG_TXT_COND_SET'), // '조건설정'
          tabComponent: tab02,
        },
        {
          tabTitle: this.$t('MSG_TXT_ACN_MAPPING'), // '액션매핑'
          tabComponent: tab03,
        },
        {
          tabTitle: this.$t('MSG_TXT_PRMT'), // '파라미터
          tabComponent: tab04,
        },
        {
          tabTitle: this.$t('MSG_TXT_ACTV_MGT'), // 활성화 관리
          tabComponent: tab05,
        },
      ],
      currentTabComponent: 'tab01',
      defaultTabIndex: 0,
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_RUL_NM'),
        datafield: 'ruleName',
      }, {
        text: this.$t('MSG_TXT_RUL_TYPE'),
        datafield: 'ruleTypeName',
      }, {
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_ACTV_YN'),
        datafield: 'activeYnName',
        width: '80px',
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'ruleUseName',
        width: '80px',
      }, {
        text: this.$t('MSG_TXT_MDFC_USR'),
        datafield: 'userName',
        width: '200px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1', // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
            datafieldMap: {
              displayLanguageId: 'displayLanguageId',
              loginId: 'loginId',
              knoxId: 'knoxId',
              userName: 'userName',
              userGlobalName: 'userGlobalName',
              departmentName: 'departmentName',
              departmentEnglishName: 'departmentEnglishName',
            },
          }, this.dsRule, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_MDFC_DTM'),
        datafield: 'finalModificationDTM',
        width: '150px',
      }],
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [{
    id: 'dsRule',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'ruleUid', map: 'ruleUid' },
      { type: 'string', name: 'ruleName', map: 'ruleName' },
      { type: 'string', name: 'ruleTypeCode', map: 'ruleTypeCode' },
      { type: 'string', name: 'moduleCode', map: 'moduleCode' },
      { type: 'string', name: 'subModuleCode', map: 'subModuleCode' },
      { type: 'string', name: 'ruleExplanationContent', map: 'ruleExplanationContent' },
      { type: 'string', name: 'dataServiceId', map: 'dataServiceId' },
      { type: 'string', name: 'pageId', map: 'pageId' },
      { type: 'string', name: 'ruleConditionContent', map: 'ruleConditionContent' },
      { type: 'string', name: 'ruleUseYn', map: 'ruleUseYn' },
      { type: 'string', name: 'nodeToDoUid', map: 'nodeToDoUid' },
      { type: 'string', name: 'moduleName', map: 'moduleName' },
      { type: 'string', name: 'subModuleName', map: 'subModuleName' },
      { type: 'string', name: 'ruleTypeName', map: 'ruleTypeName' },
      { type: 'string', name: 'ruleUseName', map: 'ruleUseName' },
      { type: 'string', name: 'loginId', map: 'loginId' },
      { type: 'string', name: 'knoxId', map: 'knoxId' },
      { type: 'string', name: 'userName', map: 'userName' },
      { type: 'string', name: 'userGlobalName', map: 'userGlobalName' },
      { type: 'string', name: 'departmentName', map: 'departmentName' },
      { type: 'string', name: 'departmentEnglishName', map: 'departmentEnglishName' },
      { type: 'string', name: 'displayLanguageId', map: 'displayLanguageId' },
      { type: 'string', name: 'finalModificationDTM', map: 'finalModificationDTM' },
      { type: 'string', name: 'dataServiceUniformresourcelocator', map: 'dataServiceUniformresourcelocator' },
      { type: 'string', name: 'dataServiceName', map: 'dataServiceName' },
      { type: 'string', name: 'activeYnName', map: 'activeYnName' },
      { type: 'string', name: 'activeYn', map: 'activeYn' }],
  }],
  mounted() {
    this.dsRule.$on(this.dsRule.EVENTS.SELECTION_CHANGED, this.datasetSelectionChanged);
  },
  destroyed() {
    this.dsRule.$off(this.dsRule.EVENTS.SELECTION_CHANGED, this.datasetSelectionChanged);
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  methods: {
    /**
     * TAB EVENT
     */
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].tabComponent;
    },
    setCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    /**
     * 룰 목록 조회
     */
    onClickSearch() {
      const queryParams = {
        ruleUid: this.frame0.ruleUid,
        ruleName: this.frame0.ruleName,
        ruleTypeCode: this.frame0.selectedCode.COD_TYPE.key,
        moduleCode: this.frame0.selectedCode.COD_MDLE.key,
        subModuleCode: this.frame0.selectedCode.COD_SMDLE.key,
        activeYn: this.frame0.selectedCode.COD_ACTV.key
      };

      http.request(this.$options.name, 'DTS_CMR_00005', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, ['finalModificationDTM']);
        this.dsRule.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
      });
    },
    /**
     * GRID ROW SELECTED EVENT
     */
    datasetSelectionChanged(data) {
      this.selectedRowData = this.dsRule.data[data.newSelections];
      this.ruleUid = this.dsRule.data[data.newSelections].ruleUid;
      this.setRuleConditionInfo = {};
    },
    /**
     * 리셋
     */
    onClickNew() {
      this.dsRule.clearSelection();
      this.setRuleConditionInfo = {};
      this.selectedRowData = '';
      this.ruleUid = '';
    },
    onClickReset() {
      utils.forEach(this.frame0, (value, key) => {
        if (utils.isEqual(key, 'selectedCode')) {
          this.$refs.ruleTypeCode.reset();
          // this.$refs.smComboFrame0.reset();
          this.frame0.selectedCode.COD_MDLE.key = 'ALL';
          this.frame0.selectedCode.COD_SMDLE.key = 'ALL';
        } else {
          this.frame0[key] = '';
        }
      });
    },
    /**
     * 팝업 EVENT
     */
    onPopupCall() {
      this.isShownPopup = true;
    },
    onPopupClose() {
      this.isShownPopup = false;
    },
    setActionMapping(data) {
      this.actionMappingList = data;
    },
    paramReturn(data, param) {
      this[param] = data;
    },
    /**
     * 팝업 EVENT
     */
    setRuleInfo(data) {
      this.selectedRowData = data;
      this.ruleUid = data.ruleUid;
    },
  },
};
</script>
<style scoped>
</style>
